import React, { useState } from "react";
import "./AddSalaryRecord.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import AddSalaryRecordLayout from "../../layouts/Admin/AddSalaryRecordLayout";

const AddSalaryRecord = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <AddSalaryRecordLayout />
    </>
  );
};

export default AddSalaryRecord;
